import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import { store } from './store';
import VueSimpleAlert from "vue-simple-alert";





Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app');

Vue.use(VueSimpleAlert);

var numeral = require("numeral");

numeral.register('locale', 'it', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function (number) {
    return number === 1 ? 'er' : 'ème';
  },
  currency: {
    symbol: '€'
  }
});

// switch between locales
numeral.locale('it');

Vue.filter("formatNumber", function (value) {
  return numeral(value).format("0,0.00"); 
});
Vue.filter("capitalizeFirstLetter", function (string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
});
